<template>
  <div>
    <div class="row">
      <div class="col-12">
        <u-help-text
          class="float-right"
          help-id="altTextHelp"
          help-title="Information"
        >
          <p>
            Zusätzliche Texte können in allen Textblöcken mit einer eckigen
            Klammer verwendet werden, z.b.
            <b>[Zusatz_1]</b>.
          </p>
          <p>
            Variablen können in allen Textblöcken mit einer geschweiften Klammer
            verwendet werden, z.b.
            <b>{NameDerVariable}</b>.
          </p>
        </u-help-text>
      </div>
    </div>

    <u-error-handling
      v-if="errorObject"
      :error-object="errorObject"
      :property-mapping="errorPropertyMappings"
    />
    <u-loader v-if="isLoading" />
    <b-tabs
      v-else
      v-model="activeTab"
      class="alternativeTextTabControl mr-4"
    >
      <b-tab title="Resultatvariable Texte">
        <b-card class="shadow-sm">
          <div
            v-for="(
              resultVariableText, resultVariableIndex
            ) in filteredTextBlocks(1)"
            :key="resultVariableIndex"
            class="mb-4 mt-4"
          >
            <div class="row mb-2">
              <div
                v-if="editTextId === resultVariableText.id"
                class="col-2 font-weight-bold"
              >
                Name
              </div>
              <div
                v-else
                class="col-11 font-weight-bold"
              >
                {{ resultVariableText.code }}
              </div>
              <div
                v-if="editTextId !== resultVariableText.id"
                class="col-1"
              >
                <button
                  v-if="canUserEdit"
                  v-b-modal.deleteTextBlock
                  v-b-tooltip.hover
                  class="btn btn-danger smallActionButton float-right mr-1 ml-1"
                  placement="bottom"
                  title="Textblock löschen"
                  type="button"
                  @click="textToDelete = resultVariableText.id"
                >
                  <i class="fas fa-trash-alt" />
                </button>
                <button
                  v-if="canUserEdit"
                  v-b-tooltip.hover
                  class="btn btn-primary smallActionButton float-right"
                  placement="bottom"
                  title="Textblock bearbeiten"
                  type="button"
                  @click="editTextId = resultVariableText.id"
                >
                  <i class="fas fa-edit" />
                </button>
              </div>
              <div
                v-if="editTextId === resultVariableText.id"
                class="col-10"
              >
                <v-select
                  v-model="resultVariableText.code"
                  :items="availableResultVariableSelections"
                  :readonly="editTextId !== resultVariableText.id"
                  label="Name"
                  menu-props="auto"
                />
              </div>
            </div>
            <div class="row my-2">
              <div class="col-2 font-weight-bold">
                <span
                  v-if="resultVariableText.type === 1"
                >Text hinter Titel</span>
                <span v-else>Text</span>
              </div>
              <div class="col-10">
                <u-multiline-multilanguage-text-input
                  id="textMulti"
                  v-model="resultVariableText.contents"
                  :is-multiline="true"
                  :readonly="editTextId !== resultVariableText.id"
                  content-property-name="text"
                />
              </div>
            </div>
            <div class="row my-2">
              <div class="col-2 font-weight-bold">
                Text in 2. Spalte
              </div>
              <div class="col-10">
                <u-multiline-multilanguage-text-input
                  id="descMulti"
                  v-model="resultVariableText.contents"
                  :is-multiline="true"
                  :readonly="editTextId != resultVariableText.id"
                  content-property-name="description"
                />
              </div>
            </div>
            <div
              v-show="editTextId === resultVariableText.id"
              class="row mt-3 mb-4"
            >
              <div class="col-12">
                <b-button
                  v-b-tooltip.hover
                  name="saveVersionEditionDetails"
                  placement="bottom"
                  title="Alle Sprachen werden gespeichert"
                  type="submit"
                  variant="success"
                  @click="saveTextBlock(resultVariableText)"
                >
                  Speichern
                </b-button>
                <b-button
                  v-b-tooltip.hover
                  class="ml-2"
                  placement="bottom"
                  title="Alle nicht gespeichert Änderungen dieses Textblockes gehen verloren"
                  variant="danger"
                  @click="editTextId = -1"
                >
                  Abbrechen
                </b-button>
              </div>
            </div>
            <hr>
          </div>
          <button
            v-if="canAddNewTextBlock() && canUserEdit"
            id="addNewTextBlockButton"
            v-b-tooltip.hover
            class="btn btn-success float-right"
            placement="bottom"
            title="Neuer Text"
            type="button"
            @click="addNewTextBlock(1)"
          >
            <i class="fas fa-plus" />
          </button>
        </b-card>
      </b-tab>
      <b-tab title="Fussnoten">
        <b-card class="shadow-sm">
          <div
            v-for="(footNoteText, footNoteTextIndex) in filteredTextBlocks(2)"
            :key="footNoteTextIndex"
          >
            <div class="row mb-2">
              <div
                v-if="editTextId === footNoteText.id"
                class="col-2 font-weight-bold"
              >
                Fussnotennummer
              </div>
              <div
                v-else
                class="col-11 font-weight-bold"
              >
                {{ footNoteText.code }}
              </div>
              <div
                v-if="editTextId !== footNoteText.id"
                class="col-1"
              >
                <button
                  v-if="canUserEdit"
                  v-b-modal.deleteTextBlock
                  v-b-tooltip.hover
                  class="btn btn-danger smallActionButton float-right mr-1 ml-1"
                  placement="bottom"
                  title="Textblock löschen"
                  type="button"
                  @click="textToDelete = footNoteText.id"
                >
                  <i class="fas fa-trash-alt" />
                </button>
                <button
                  v-if="canUserEdit"
                  v-b-tooltip.hover
                  class="btn btn-primary smallActionButton float-right"
                  placement="bottom"
                  title="Textblock bearbeiten"
                  type="button"
                  @click="editTextId = footNoteText.id"
                >
                  <i class="fas fa-edit" />
                </button>
              </div>
              <div
                v-if="editTextId === footNoteText.id"
                class="col-2"
              >
                <v-text-field
                  v-model="footNoteText.code"
                  label="Fussnotennummer"
                  type="number"
                />
              </div>
            </div>
            <div class="row my-2">
              <div class="col-2 font-weight-bold">
                Text
              </div>
              <div class="col-10">
                <div
                  v-show="editTextId !== footNoteText.id"
                  class="row"
                >
                  <div
                    v-for="lang in languages"
                    :key="lang"
                    class="col-sm"
                  >
                    <v-subheader>
                      {{ translatableLanguages[lang].label }}
                    </v-subheader>
                    <p
                      v-safe-html="
                        getContentForLanguage(
                          footNoteText.contents,
                          lang,
                          'text',
                          '',
                        )
                      "
                    />
                  </div>
                </div>
                <div
                  v-show="editTextId === footNoteText.id"
                  class="row"
                >
                  <div
                    v-for="lang in languages"
                    :key="lang"
                    class="col-sm"
                  >
                    <v-subheader>
                      {{ translatableLanguages[lang].label }}
                    </v-subheader>
                    <div style="display: grid">
                      <div
                        class="ml-auto"
                        style="font-size: 25px"
                      >
                        <i
                          v-b-tooltip.hover
                          class="fas fa-language"
                          placement="bottom"
                          title="Wert für alle Sprachen übernehmen"
                          type="button"
                          @click="
                            setAllLanguageTexts(
                              footNoteText.contents,
                              lang,
                              'text',
                            )
                          "
                        />
                      </div>
                    </div>
                    <tiny-mce-editor
                      :value="
                        getTextBlockContent(footNoteText.contents, lang, 'text')
                      "
                      @input="
                        updateTextBlockContent(
                          footNoteText.contents,
                          lang,
                          'text',
                          $event,
                        )
                      "
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              v-show="editTextId === footNoteText.id"
              class="row mt-3 mb-4"
            >
              <div class="col-12">
                <b-button
                  v-b-tooltip.hover
                  name="saveVersionEditionDetails"
                  placement="bottom"
                  title="Alle Sprachen werden gespeichert"
                  type="submit"
                  variant="success"
                  @click="saveTextBlock(footNoteText)"
                >
                  Speichern
                </b-button>
                <b-button
                  v-b-tooltip.hover
                  class="ml-2"
                  placement="bottom"
                  title="Alle nicht gespeichert Änderungen dieses Textblockes gehen verloren"
                  variant="danger"
                  @click="editTextId = -1"
                >
                  Abbrechen
                </b-button>
              </div>
            </div>
            <hr>
          </div>
          <button
            v-if="canAddNewTextBlock() && canUserEdit"
            id="addNewTextBlockButton"
            v-b-tooltip.hover
            class="btn btn-success float-right"
            placement="bottom"
            title="Neuer Text"
            type="button"
            @click="addNewTextBlock(2)"
          >
            <i class="fas fa-plus" />
          </button>
        </b-card>
      </b-tab>
      <b-tab title="Zusätzlicher Text">
        <b-card class="shadow-sm">
          <div
            v-for="(additionalText, additionalTextIndex) in filteredTextBlocks(
              3,
            )"
            :key="additionalTextIndex"
          >
            <div class="row mb-2">
              <div
                v-if="editTextId === additionalText.id"
                class="col-2 font-weight-bold"
              >
                Zusätzlicher Text Nummer
              </div>
              <div
                v-else
                class="col-11 font-weight-bold"
              >
                {{ additionalText.code }}
              </div>
              <div
                v-if="editTextId !== additionalText.id"
                class="col-1"
              >
                <button
                  v-if="canUserEdit"
                  v-b-modal.deleteTextBlock
                  v-b-tooltip.hover
                  class="btn btn-danger smallActionButton float-right mr-1 ml-1"
                  placement="bottom"
                  title="Textblock löschen"
                  type="button"
                  @click="textToDelete = additionalText.id"
                >
                  <i class="fas fa-trash-alt" />
                </button>
                <button
                  v-if="canUserEdit"
                  v-b-tooltip.hover
                  class="btn btn-primary smallActionButton float-right"
                  placement="bottom"
                  title="Textblock bearbeiten"
                  type="button"
                  @click="editTextId = additionalText.id"
                >
                  <i class="fas fa-edit" />
                </button>
              </div>
              <div
                v-if="editTextId === additionalText.id"
                class="col-2"
              >
                <v-text-field
                  v-model="additionalText.code"
                  label="Zusätzlicher Text Nummer"
                  type="number"
                />
              </div>
            </div>
            <div class="row my-2">
              <div class="col-2 font-weight-bold">
                Text
              </div>
              <div class="col-10">
                <div
                  v-show="editTextId !== additionalText.id"
                  class="row"
                >
                  <div
                    v-for="lang in languages"
                    :key="lang"
                    class="col-sm"
                  >
                    <v-subheader>
                      {{ translatableLanguages[lang].label }}
                    </v-subheader>
                    <p
                      v-safe-html="
                        getContentForLanguage(
                          additionalText.contents,
                          lang,
                          'text',
                          '',
                        )
                      "
                    />
                  </div>
                </div>
                <div
                  v-show="editTextId === additionalText.id"
                  class="row"
                >
                  <div
                    v-for="lang in languages"
                    :key="lang"
                    class="col-sm"
                  >
                    <v-subheader>
                      {{ translatableLanguages[lang].label }}
                    </v-subheader>
                    <div style="display: grid">
                      <div
                        class="ml-auto"
                        style="font-size: 25px"
                      >
                        <i
                          v-b-tooltip.hover
                          class="fas fa-language"
                          placement="bottom"
                          title="Wert für alle Sprachen übernehmen"
                          type="button"
                          @click="
                            setAllLanguageTexts(
                              additionalText.contents,
                              lang,
                              'text',
                            )
                          "
                        />
                      </div>
                    </div>
                    <tiny-mce-editor
                      :value="
                        getTextBlockContent(
                          additionalText.contents,
                          lang,
                          'text',
                        )
                      "
                      @input="
                        updateTextBlockContent(
                          additionalText.contents,
                          lang,
                          'text',
                          $event,
                        )
                      "
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              v-show="editTextId === additionalText.id"
              class="row mt-3 mb-4"
            >
              <div class="col-12">
                <b-button
                  v-b-tooltip.hover
                  name="saveVersionEditionDetails"
                  placement="bottom"
                  title="Alle Sprachen werden gespeichert"
                  type="submit"
                  variant="success"
                  @click="saveTextBlock(additionalText)"
                >
                  Speichern
                </b-button>
                <b-button
                  v-b-tooltip.hover
                  class="ml-2"
                  placement="bottom"
                  title="Alle nicht gespeichert Änderungen dieses Textblockes gehen verloren"
                  variant="danger"
                  @click="editTextId = -1"
                >
                  Abbrechen
                </b-button>
              </div>
            </div>
            <hr>
          </div>
          <button
            v-if="canAddNewTextBlock() && canUserEdit"
            id="addNewTextBlockButton"
            v-b-tooltip.hover
            class="btn btn-success float-right"
            placement="bottom"
            title="Neuer Text"
            type="button"
            @click="addNewTextBlock(3)"
          >
            <i class="fas fa-plus" />
          </button>
        </b-card>
      </b-tab>
    </b-tabs>
    <b-modal
      v-if="canUserEdit"
      id="deleteTextBlock"
      ref="deleteTextBlock"
      hide-footer
      no-fade
      title="Textblock löschen"
    >
      <div class="d-block mb-4">
        Sind Sie sicher, dass Sie diesen Textblock löschen möchten?
      </div>
      <b-button
        variant="success"
        @click="deleteTextBlock()"
      >
        Ok
      </b-button>
      <b-button
        class="ml-2"
        variant="danger"
        @click="hideModal('deleteTextBlock')"
      >
        Abbrechen
      </b-button>
    </b-modal>
  </div>
</template>

<script>
import TinyMceEditor from "@/components/common/tinyMceEditor.vue";
import ULoader from "@/components/common/ULoader.vue";
import UErrorHandling from "@/components/common/UErrorHandling.vue";
import {
  LoadAllTextBlocks,
  SaveTextBlock,
  AddNewTextBlock,
  DeleteTextBlock,
} from "@/services/minimum.wage.services/textBlocks.minimum.wages.js";
import { MultiLangMixin } from "@/mixins/MultilanguageContentsMixin";
import { MinimumWageMixin } from "@/components/minimum.wage/mixins/MinimumWageMixin";

export default {
  components: {
    TinyMceEditor,
    ULoader,
    UErrorHandling,
  },
  mixins: [MultiLangMixin, MinimumWageMixin],
  data() {
    return {
      isLoading: false,
      errorObject: null,
      activeTab: 0,
      textBlocks: [],
      originalTextBlocks: [],
      editTextId: -1,
      textToDelete: null,
      languages: ["de-CH", "fr-CH", "it-CH"],
      errorPropertyMappings: null,
      translatableLanguages: {
        "de-CH": { language: "de-CH", label: "Deutsch" },
        "fr-CH": { language: "fr-CH", label: "Französisch" },
        "it-CH": { language: "it-CH", label: "Italienisch" },
      },
      resultVariableSelection: [
        "Mindestmonatslohn",
        "AnzahlFerientage",
        "AnzahlFeiertage",
        "Has13Monatslohn",
        "Basisstundenlohn",
        "AnteilFerienentschädigung",
        "AnteilFeiertagsentschädigung",
        "Entschädigung13Monatslohn",
        "Bruttostundenlohn",
        "FARAGBeitrag",
        "FARANBeitrag",
      ],
    };
  },
  computed: {
    availableResultVariableSelections() {
      // Get the currently selected codes, excluding the current one being edited
      const selectedCodes = this.textBlocks
        .filter((textBlock) => textBlock.id !== this.editTextId)
        .map((textBlock) => textBlock.code);

      // Filter the selection list, always including the current selection
      return this.resultVariableSelection.filter(
        (item) =>
          !selectedCodes.includes(item) ||
          item ===
            this.textBlocks.find(
              (textBlock) => textBlock.id === this.editTextId,
            )?.code,
      );
    },
  },
  watch: {
    activeTab() {
      this.loadTranslatedLanguages();
    },
    editTextId(newValue) {
      if (newValue !== 0) {
        this.textBlocks = JSON.parse(JSON.stringify(this.originalTextBlocks));
      }
    },
  },
  created() {
    this.loadAllTextBlocks();
    this.loadTranslatedLanguages();
  },
  methods: {
    loadTranslatedLanguages() {
      if (
        this.$store.state.mindestLohnKonfiguration.BasicContractInformation
          .translatedLanguages
      ) {
        this.languages = [];
        this.$store.state.mindestLohnKonfiguration.BasicContractInformation.translatedLanguages.forEach(
          (translatedLanguage) => {
            this.languages.push(translatedLanguage.language);
          },
        );
      }
    },
    filteredTextBlocks(type) {
      return this.textBlocks.filter((textBlock) => textBlock.type === type);
    },
    isLanguageEnabled(language) {
      return this.languages.includes(language);
    },
    hideModal(modalId) {
      this.$refs[modalId].hide();
    },
    loadAllTextBlocks() {
      this.isLoading = true;
      this.errorObject = null;

      LoadAllTextBlocks(
        this.contractId,
        this.versionId,
        this.editionId,
        (response) => {
          this.isLoading = false;
          this.textBlocks = JSON.parse(JSON.stringify(response));
          this.originalTextBlocks = JSON.parse(JSON.stringify(response));
        },
        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
    addNewTextBlock(type) {
      const newTextBlock = {
        id: 0,
        code: "Neuer Textblock",
        configurationId: 0,
        type: type,
        tenantId: 1,
        contents: this.languages.map((language) => ({
          id: 0,
          textblockId: 0,
          text: "",
          description: "",
          value: language,
          language: language,
        })),
      };

      this.textBlocks.push(JSON.parse(JSON.stringify(newTextBlock)));
      setTimeout(() => {
        this.editTextId = 0;
      }, 50);
    },
    canAddNewTextBlock() {
      return (
        this.textBlocks.every((textBlock) => textBlock.id !== 0) &&
        this.$IsUserInRole("VertragsmanagementVerwaltung")
      );
    },
    updateContent(index, value, propertyName) {
      this.textBlocks[index].contents.forEach((content) => {
        content[propertyName] = value;
      });
    },
    getTextBlockContent(contents, language, propertyName) {
      const content = contents.find((c) => c.language === language);
      return content ? content[propertyName] : "";
    },
    updateTextBlockContent(contents, language, propertyName, value) {
      const content = contents.find((c) => c.language === language);
      if (content) {
        content[propertyName] = value;
      }
    },
    setAllLanguageTexts(contents, language, propertyName) {
      const contentToCopy = contents.find((c) => c.language === language);
      if (contentToCopy) {
        contents.forEach((content) => {
          content[propertyName] = contentToCopy[propertyName];
        });
      }
    },
    createErrorPropertyMappings() {
      const mapping = {};
      this.languages.forEach((availableLanguage, index) => {
        mapping[`Contents[${index}].text`] = `${
          this.translatableLanguages[availableLanguage].label
        } - Text in 2. Spalte`;
        mapping[`Contents[${index}].description`] = `${
          this.translatableLanguages[availableLanguage].label
        } - Text hinter Titel`;
      });
      return mapping;
    },
    saveTextBlock(textBlockToSave) {
      this.isLoading = true;
      this.errorObject = false;
      this.errorPropertyMappings = this.createErrorPropertyMappings();
      textBlockToSave.contents.forEach((content) => {
        content.value = content.language;
      });

      if (textBlockToSave.id !== 0) {
        SaveTextBlock(
          this.contractId,
          this.versionId,
          this.editionId,
          textBlockToSave,
          () => {
            this.editTextId = -1;
            this.loadAllTextBlocks();
          },
          (error) => {
            this.errorObject = error;
            this.isLoading = false;
          },
        );
      } else {
        AddNewTextBlock(
          this.contractId,
          this.versionId,
          this.editionId,
          textBlockToSave,
          () => {
            this.editTextId = -1;
            this.loadAllTextBlocks();
          },
          (error) => {
            this.errorObject = error;
            this.isLoading = false;
          },
        );
      }
    },
    deleteTextBlock() {
      this.isLoading = true;
      this.errorObject = false;

      DeleteTextBlock(
        this.contractId,
        this.versionId,
        this.editionId,
        this.textToDelete,
        () => {
          this.editTextId = -1;
          this.hideModal("deleteTextBlock");
          this.loadAllTextBlocks();
        },
        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
  },
};
</script>

<style>
.alternativeTextTabControl .shadow-sm {
  border-top: none;
  border-radius: 0px;
}
</style>

<style scoped>
.smallActionButton {
  width: 30px;
  height: 30px;
  font-size: 17px;
  padding: 0px;
}
</style>
